import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { RequestFlowService } from '../services/request-flow.service';

@Component({
  selector: 'request-flow',
  templateUrl: './request-flow.component.html',
  styleUrls: ['./request-flow.component.scss']
})
export class RequestFlowComponent implements OnInit {
  formData!: any;
  userDetails!: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public requestFlowService: RequestFlowService,
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.data.userDetails) {
      const { first_name, last_name, email, mobile, partner, slug } = this.route.snapshot.data.userDetails;

      this.userDetails = {
        first_name,
        last_name,
        email,
        phone: mobile,
        partner_slug: partner.slug,
        user_slug: slug
      };
    } else {
      // redirect the user to Support Flow when there's no user details
      this.router.navigate(['/support']);
    }

    if (!this.formData) {
      this.formData = this.requestFlowService.getFirstStep( this.userDetails);
    }
  }

}
